import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lock, Mail, ArrowRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LoginPage = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Ingresa email y contraseña");
      return;
    }

    setIsLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, 
        { email, password },
        { withCredentials: true }
      );
      
      const { token, ...user } = res.data;
      localStorage.setItem("admin_token", token);
      onLogin(user);
      toast.success("Bienvenido, Administrador");
      navigate("/admin");
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Error al iniciar sesión");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5] p-4">
      <div className="w-full max-w-md">
        <div className="bg-white border border-[#E5E5E5] overflow-hidden">
          {/* Header */}
          <div className="bg-[#EA580C] p-8 text-center">
            <Lock className="w-10 h-10 text-white mx-auto mb-3" />
            <h1 className="text-2xl font-bold text-white" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
              Administración
            </h1>
            <p className="text-white/70 text-sm mt-1">Casa Ciudadana Zapopan</p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="p-8 space-y-6" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="login-email" className="label-text flex items-center gap-2">
                <Mail className="w-4 h-4" />
                Email
              </Label>
              <Input
                id="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@casaciudadana.com"
                className="input-swiss rounded-none"
                data-testid="login-email"
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="login-password" className="label-text flex items-center gap-2">
                <Lock className="w-4 h-4" />
                Contraseña
              </Label>
              <Input
                id="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Ingresa tu contraseña"
                className="input-swiss rounded-none"
                data-testid="login-password"
                required
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="btn-primary w-full flex items-center justify-center gap-2"
              data-testid="login-submit"
            >
              {isLoading ? "Ingresando..." : (
                <>
                  Ingresar
                  <ArrowRight className="w-5 h-5" />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
